import { Box } from "@chakra-ui/react";
import { ReactNode } from "react";

export const RanaSelectOptionLabel = ({
  searchString,
  content,
}: {
  searchString: string;
  content: ReactNode | ((searchString: string) => ReactNode);
}) => {
  if (typeof content === "function") {
    return <>{content(searchString)}</>;
  }

  if (typeof content === "string") {
    const textSegments = content.split(new RegExp(`(${searchString})`, "gi"));
    return textSegments.map((segment, index) =>
      // Highlight searchstring
      segment.toLowerCase() === searchString.toLowerCase() ? (
        <Box as="mark" key={index} fontWeight="700" color="brand.bg" bg="brand.clear_creek">
          {segment}
        </Box>
      ) : (
        segment
      )
    );
  }
  return content;
};
